module.exports = __webpack_public_path__ + "img/5-2_05.0a256a27.jpg";